import * as THREE from 'three';
import { Entity } from '../../entities';

export interface StarOptions {
  readonly radius: number;
  readonly core: number;
  readonly glow: number;
  readonly corona: number;
  readonly position?: THREE.Vector3;
  readonly lightIntensity?: number;
  readonly lightRange?: number;
}

export class Star extends Entity {
  readonly radius: number;
  readonly lightColor: number;

  constructor(options: StarOptions) {
    super();
    this.radius = options.radius;
    this.lightColor = options.glow;
    if (options.position) this.object3D.position.copy(options.position);

    const coreColor = new THREE.Color(options.core).multiplyScalar(2.6);
    const coreMat = new THREE.MeshBasicMaterial({
      color: coreColor,
      toneMapped: false,
      fog: false
    });
    const core = new THREE.Mesh(
      new THREE.SphereGeometry(options.radius, 48, 32),
      coreMat
    );
    core.name = 'star-core';
    core.renderOrder = -2;
    this.object3D.add(core);

    const glowColor = new THREE.Color(options.glow).multiplyScalar(1.0);
    const softGlowMat = new THREE.MeshBasicMaterial({
      color: glowColor,
      transparent: true,
      opacity: 0.22,
      side: THREE.BackSide,
      depthWrite: false,
      toneMapped: false,
      fog: false,
      blending: THREE.AdditiveBlending
    });
    const softGlow = new THREE.Mesh(
      new THREE.SphereGeometry(options.radius * 1.08, 40, 24),
      softGlowMat
    );
    softGlow.name = 'star-soft-glow';
    this.object3D.add(softGlow);

    const light = new THREE.PointLight(
      options.glow,
      options.lightIntensity ?? 2.0,
      options.lightRange ?? 0,
      options.lightRange ? 1.4 : 0
    );
    this.object3D.add(light);
  }

  getWorldPosition(out: THREE.Vector3): THREE.Vector3 {
    return out.copy(this.object3D.position);
  }
}
